import type { InvalidateOptions, QueryClient } from '@tanstack/vue-query';
import type { IEntryAttachmentTarget } from 'common/enum/entry.attachment.enum';
import { entryAttachmentKeys } from './entryAttachment.keys';

/** Refresh this entry's lists across cached user/role scopes without touching other entries or file images. */
export const invalidateEntryAttachmentQueries = (
  queryClient: QueryClient,
  target: IEntryAttachmentTarget,
  options?: InvalidateOptions,
): Promise<void> => queryClient.invalidateQueries({ queryKey: entryAttachmentKeys.entry(target) }, options);
